import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { sendFiltersAdapter } from './adapters'
import axios from 'axios'
import { users } from './db/users'
import { getTemporalToken } from '../../../billing-api'
import {
  getCities,
  getDistricts,
  getCountries,
  getDepartments,
  getDocuments,
  getDocumentTypes,
  getEconomicActivities,
  getMeasurementUnit,
  getMHTransaction,
  getOfferTypes,
  getPaymentMethod,
  getTerms,
  getOperationConditions,
  getProductTypes,
  getSaleTypes,
  getTaxpayerTypes,
  getPersonTypes,
  setProductsCreditJsonList,
  setProductsCreditList,
  submitMHContingencyDte,
  submitMHInvalidateDte,
  submitMHTransaction,
} from './thunks'
import {
  getAPIEndpointURL,
  getInternalLogHeader,
} from '../../../utility/utils'

const REACT_APP_API_QA_URL = getAPIEndpointURL()

export const getTransactions = createAsyncThunk(
  'appInvoice/getTransactions',
  async (filters) => {
    const cleanFilters = sendFiltersAdapter(filters)
    const userName = JSON.parse(localStorage.getItem('userBilligData'))
    const userLogin = { companyId: userName.username }
    const user = users.find(
      (user) => user?.companyId === userLogin?.companyId
    )

    try {
      const token = await getTemporalToken(user)
      const axiosInstance = axios.create({
        baseURL: `${REACT_APP_API_QA_URL}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          ...getInternalLogHeader(user?.userName),
        },
        mode: 'no-cors',
      })
      const getTransactions = await axiosInstance.get(
        '/api/transaction/dte-list',
        {
          params: { ...cleanFilters, size: 2000, isSuccessful: 0 },
        }
      )
      return getTransactions?.data?.content
    } catch (error) {
      console.log(error)
      return error
    }
  }
)

export const downloadInvoiceJSON = createAsyncThunk(
  'appInvoice/dowloadInvoiceJSON',
  async (params) => {
    const userName = JSON.parse(localStorage.getItem('userBilligData'))
    const userLogin = { companyId: userName.username }
    const user = users.find(
      (user) => user?.companyId === userLogin?.companyId
    )

    if (!user) throw new Error('User not found')

    try {
      const token = await getTemporalToken(user)
      const axiosInstance = axios.create({
        baseURL: `${REACT_APP_API_QA_URL}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        mode: 'no-cors',
      })
      const downloadInvoiceJSON = await axiosInstance.get(
        `/api/transaction/json-mh/${user?.id}/${params.generationCode}/${params.emissionDate}`
      )
      return downloadInvoiceJSON.data
    } catch (error) {
      if (error?.response?.status === 404) {
        return {
          error: true,
          payload: {
            rubridocTransactionStatusMsj: `No se encontró el archivo ${params.generationCode}`,
          },
        }
      }
      throw error
    }
  }
)

export const downloadInvoiceJsonMh = createAsyncThunk(
  'appInvoice/dowloadInvoiceJSON',
  async (params) => {
    const userName = JSON.parse(localStorage.getItem('userBilligData'))
    const userLogin = { companyId: userName.username }
    const user = users.find(
      (user) => user?.companyId === userLogin?.companyId
    )

    if (!user) throw new Error('User not found')

    try {
      const token = await getTemporalToken(user)
      const axiosInstance = axios.create({
        baseURL: `${REACT_APP_API_QA_URL}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          ...getInternalLogHeader(user.userName),
        },
        mode: 'no-cors',
      })
      const downloadInvoiceJSON = await axiosInstance.get(
        `/api/transaction/json/${user?.id}/${params.generationCode}/${params.emissionDate}`
      )
      return downloadInvoiceJSON.data
    } catch (error) {
      if (error?.response?.status === 404) {
        return {
          error: true,
          payload: {
            rubridocTransactionStatusMsj: `No se encontró el archivo ${params.generationCode}`,
          },
        }
      }
      throw error
    }
  }
)

export const downloadInvoices = createAsyncThunk(
  'appInvoice/downloadInvoices',
  async (params) => {
    const userName = JSON.parse(localStorage.getItem('userBilligData'))
    const userLogin = { companyId: userName.username }
    const user = users.find(
      (user) => user?.companyId === userLogin?.companyId
    )

    if (!user) throw new Error('User not found')

    try {
      const token = await getTemporalToken(user)
      const axiosInstance = axios.create({
        baseURL: `${REACT_APP_API_QA_URL}`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/pdf',
          ...getInternalLogHeader(user.userName),
        },
        // mode: 'no-cors'
      })
      const downloadInvoices = await axiosInstance.get(
        `/api/transaction/${user?.id}/${params.generationCode}/${params.emissionDate}`,
        {
          responseType: 'blob',
        }
      )
      return downloadInvoices.data
    } catch (error) {
      if (error?.response?.status === 404) {
        return {
          error: true,
          payload: {
            rubridocTransactionStatusMsj: `No se encontró el archivo ${params.generationCode}`,
          },
        }
      }
      throw error
    }
  }
)

export const setUserAction = createAsyncThunk(
  'appInvoice/setUser',
  async (user) => {
    return user
  }
)

export const setProductsCreditAction = createAsyncThunk(
  'appInvoice/setProducts',
  async (products) => {
    return products
  }
)

export const setDatasBillAction = createAsyncThunk(
  'appInvoice/setDataBill',
  async (billData) => {
    return billData
  }
)

const initialState = {
  receptor: {},
  products: [],
  isPending: false,
  bill: {
    products: [],
    total: 0,
  },
  identificacion: {},
  emisor: {
    nit: '06143005191014',
    nrc: '280341-5',
    nombre: 'Technologies Consultancy and Services, S.A. de C.V.',
    codActividad: '45100',
    descActividad: 'Venta de vehículos automotores',
    nombreComercial: 'TechyWe',
    direccion: {
      departamento: '05',
      municipio: '23',
      distrito: '01',
      complemento:
        'Calle Teotl sda. 3, Res. Cumbres de la Esmeralda, # 5, Antgo. Cuscatlán, La Libertad Este, La Libertad',
    },
    telefono: '78592291',
    correo: 'contabilidad@techy-we.com',
    codEstable: 'M001',
    codPuntoVenta: 'P001',
    // tipoItemExpor (#34), recintoFiscal (#35), tipoRegimen (#36) y regimen (#37)
    // son exclusivos de FEXE: se agregan al armar el DTE, no aquí.
    // updateEmisor hace merge, así que dejarlos aquí los filtraría al resto de DTE
  },
  cuerpoDocumento: [],
  resumen: {},
  countries: [],
  departments: [],
  cities: [],
  districts: [],
  economicActivities: [],
  documentTypes: [],
  measurementUnits: [],
  productTypes: [],
  saleTypes: [],
  paymentMethods: [],
  terms: [],
  operationConditionsCatalog: [],
  documentList: [],
  offerTypes: [],
  // CAT-091 y CAT-029: sus id dependen del ambiente, se cargan del backend
  taxpayerTypes: [],
  personTypes: [],
  relatedDoc: null,

  emailConfig: {
    accountType: null,
    emailProvider: null,
    authorized: false,
    isActive: false,
  },
}

export const appInvoiceSlice = createSlice({
  initialState,
  name: 'appInvoice',
  reducers: {
    setInitialData: (state) => {
      state.receptor = {}
      state.products = []
    },
    updateEmisor: (state, action) => {
      state.emisor = {
        ...state.emisor,
        ...action.payload,
      }
    },
    updateEmailConfig: (state, action) => {
      state.emailConfig = {
        ...state.emailConfig,
        ...action.payload,
      }
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getTransactions.fulfilled, (state, action) => {
        state.receptor = action.payload
        state.isPending = false
      })
      .addCase(getTransactions.pending, (state, action) => {
        state.isPending = true
      })
      .addCase(getTransactions.rejected, (state, action) => {
        state.isPending = false
      })
      /* Envió de transacciones a MH */
      .addCase(submitMHTransaction.fulfilled, (state, action) => {
        state.isPending = false
      })
      .addCase(submitMHTransaction.pending, (state, action) => {
        state.isPending = true
      })
      .addCase(submitMHTransaction.rejected, (state, action) => {
        state.isPending = false
      })
      .addCase(submitMHInvalidateDte.fulfilled, (state, action) => {
        state.isPending = false
      })
      .addCase(submitMHInvalidateDte.pending, (state, action) => {
        state.isPending = true
      })
      .addCase(submitMHInvalidateDte.rejected, (state, action) => {
        state.isPending = false
      })
      .addCase(submitMHContingencyDte.fulfilled, (state, action) => {
        state.isPending = false
      })
      .addCase(submitMHContingencyDte.pending, (state, action) => {
        state.isPending = true
      })
      .addCase(submitMHContingencyDte.rejected, (state, action) => {
        state.isPending = false
      })

      /* Catalogos */

      .addCase(getOfferTypes.fulfilled, (state, action) => {
        state.isPending = false
        state.offerTypes = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getDepartments.fulfilled, (state, action) => {
        state.isPending = false
        state.departments = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.isPending = false
        state.countries = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getTaxpayerTypes.fulfilled, (state, action) => {
        state.isPending = false
        state.taxpayerTypes = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getPersonTypes.fulfilled, (state, action) => {
        state.isPending = false
        state.personTypes = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getCities.fulfilled, (state, action) => {
        state.isPending = false
        state.cities = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getDistricts.fulfilled, (state, action) => {
        state.isPending = false
        state.districts = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getEconomicActivities.fulfilled, (state, action) => {
        state.isPending = false
        state.economicActivities = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getDocumentTypes.fulfilled, (state, action) => {
        state.isPending = false
        state.documentTypes = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getMeasurementUnit.fulfilled, (state, action) => {
        state.isPending = false
        state.measurementUnits = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getProductTypes.fulfilled, (state, action) => {
        state.isPending = false
        state.productTypes = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getSaleTypes.fulfilled, (state, action) => {
        state.isPending = false
        state.saleTypes = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getPaymentMethod.fulfilled, (state, action) => {
        state.isPending = false
        state.paymentMethods = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getTerms.fulfilled, (state, action) => {
        state.isPending = false
        state.terms = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(getOperationConditions.fulfilled, (state, action) => {
        state.isPending = false
        if (Array.isArray(action.payload) && action.payload.length) {
          state.operationConditionsCatalog = action.payload
        }
      })
      .addCase(getMHTransaction.fulfilled, (state, action) => {
        state.isPending = false
        state.paymentMethods = action.payload
      })
      .addCase(getDocuments.fulfilled, (state, action) => {
        state.isPending = false
        state.documentList = action.payload?.content
      })

      /* Administracion de usuarios */
      .addCase(setUserAction.fulfilled, (state, action) => {
        const user = action.payload
        state.receptor = user
      })
      /* Administracion de productos y factura */
      .addCase(setProductsCreditAction.fulfilled, (state, action) => {
        const products = action.payload
        state.products = products
      })
      .addCase(setDatasBillAction.fulfilled, (state, action) => {
        const billData = action.payload
        state.bill = billData
      })
      .addCase(setProductsCreditList.rejected, (state, action) => {
        state.isPending = false
        state.products = []
      })
      .addCase(setProductsCreditList.fulfilled, (state, action) => {
        const products = action.payload?.transformData
        state.products = products
        state.relatedDoc = action.payload.relatedDoc
      })
      .addCase(setProductsCreditJsonList.rejected, (state, action) => {
        state.isPending = false
        state.products = []
      })
      .addCase(setProductsCreditJsonList.fulfilled, (state, action) => {
        const products = action.payload?.transformData
        state.products = products
        state.relatedDoc = action.payload.relatedDoc
      }),
  /*.addCase(setRelatedDoc.fulfilled, (state, action) => {
    console.log("action.payload: ", action.payload)
    state.relatedDoc = action.payload;
  })*/
})

export const { setInitialData, updateEmisor, updateEmailConfig } =
  appInvoiceSlice.actions

export default appInvoiceSlice.reducer
